import type { SVGProps } from 'react';

/**
 * Tailscale brand mark: a 3×3 grid of dots where the middle row and the
 * bottom-centre dot are solid (forming Tailscale's signature "T") and the
 * remaining dots sit at 40% opacity. Geometry is taken verbatim from the
 * official Tailscale brand toolkit icon (`Tailscale_icon_*_rgb.svg`,
 * 169×169 viewBox, r=18 circles).
 *
 * Uses `currentColor` so it inherits the surrounding text colour (e.g. the
 * nav's foreground in both light and dark themes), matching how the stock
 * Lucide icons it replaces behave.
 */
const TailscaleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 169 169" fill="currentColor">
    {/* Middle row — solid */}
    <circle cx="30.5" cy="84.5" r="18" />
    <circle cx="84.5" cy="84.5" r="18" />
    <circle cx="138.5" cy="84.5" r="18" />
    {/* Bottom-centre — solid */}
    <circle cx="84.5" cy="138.5" r="18" />
    {/* Top row + bottom corners — 40% opacity */}
    <circle cx="30.5" cy="30.5" r="18" fillOpacity="0.4" />
    <circle cx="84.5" cy="30.5" r="18" fillOpacity="0.4" />
    <circle cx="138.5" cy="30.5" r="18" fillOpacity="0.4" />
    <circle cx="30.5" cy="138.5" r="18" fillOpacity="0.4" />
    <circle cx="138.5" cy="138.5" r="18" fillOpacity="0.4" />
  </svg>
);

export { TailscaleIcon };
